var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"categories"},[_c('PostPreviewList',{attrs:{"posts":_vm.filteredCategories,"postRouteName":"catalogue.category","buttonText":"More"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }